import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="grid-bg w-full bg-night px-5 py-12" aria-labelledby="garantia-titulo" data-id="element-61" data-mp="4uqdmw6js2tb">
      <div className="mx-auto flex max-w-3xl flex-col items-center rounded-xl border border-gold/40 bg-night-card px-7 py-12 text-center" data-id="element-62" data-mp="9ttkmm638j3x">
        <ShieldCheckIcon className="h-12 w-12 text-gold" aria-hidden="true" data-id="element-63" data-mp="ev0q2ekrd67f" />
        <h2 id="garantia-titulo" className="mt-6 font-display text-2xl font-bold text-cream md:text-3xl" data-id="element-64" data-mp="jrhg5ebipun5">
          Garantía incondicional de 7 días
        </h2>
        <p className="mt-5 max-w-xl text-base leading-relaxed text-cream-dim md:text-lg" data-id="element-65" data-mp="skudqtkj1kfk">
          Descarga la guía, revísala completa y estúdiala con calma. Si en 7 días sientes que no era para ti, escríbenos
          y te devolvemos el 100% de tu dinero. Sin preguntas y sin trámites.
        </p>
      </div>
    </section>;
}